import { useTranslation } from 'react-i18next';

import { ControlledMaskedTextField, Fieldset, HelperText } from '@components';
import { EditMode } from '@types';

export const HouseholdIncome = ({ editMode }: EditMode) => {
  const { t } = useTranslation('subModules/householdIncome');

  return (
    <Fieldset label={t('label')} data-tf-sensitive="true" required>
      <ControlledMaskedTextField
        maskType="currency"
        fieldName="householdIncome"
        label={editMode ? '' : t('amount')}
        inputMode="numeric"
        currencyIcon
        infoTooltipText={editMode ? '' : t('tooltip')}
        enterKeyHint="next"
        placeholder="0"
        data-testid="householdIncomeSubModule"
        data-tf-sensitive="true"
      />
      <HelperText>{t('helperText')}</HelperText>
    </Fieldset>
  );
};
